// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"35947263","320":"88fae67c","510":"b413041e","832":"5f44bc73","911":"5f3afc46"}[chunkId] + ".chunk.js";
};